import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@teem/environments/environment';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import * as Api from '@teem/core/constants/api';
import { queryString } from '@teem/helpers/functions';
import { LoaderService } from '@teem/services/loader.service';

// Extend JQuery type to include niceSelect
declare global {
  interface JQuery {
	niceSelect(method?: string): JQuery;
  }
}

@Component({
	selector: 'app-influencer-analytics',
	templateUrl: './influencer-analytics.component.html',
	styleUrls: ['./influencer-analytics.component.scss']
})
export class InfluencerAnalyticsComponent implements OnInit {

	data: any[] = [];
	paginator = {
		id: 'table-paginator',
		currentPage: 1,
		itemsPerPage: 10,
		totalItems: 0,
		from: 0,
		to: 0,
		lastPage: 1
	};

	itemsPerPageOptions = [10, 20, 50, 100];
	loading = false;
	onLoad = new EventEmitter();
	stats = [];
	currentSort = '';
	sortColumn = '';
	sortDirection = 'asc';
	@Output() sortRequested = new EventEmitter<{ column: string; direction: string }>();

	constructor(
		private http: HttpClient,
		private loaderService: LoaderService
	) { }

	ngOnInit(): void {
		this.getPage(1);
	}
	searchTerm: string = '';

	searchInfluencer(term: string) {
		this.searchTerm = term;
		this.getPage(1);
	}

	orderCampaign(selectedValue: string) {
		console.log('Selected value:', selectedValue);

		// Example: If this is for sorting or filtering
		this.currentSort = selectedValue;
		this.getPage(1);
	}

	sortData(column: string) {
		// Toggle sort direction if the same column is clicked
		if (this.sortColumn === column) {
			this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
		} else {
			// New column clicked, reset to ascending
			this.sortColumn = column;
			this.sortDirection = 'asc';
		}

		// Emit event to the parent component to call the API
		// this.sortRequested.emit({ column: column, direction: this.sortDirection });
		this.getPage(1);
	}

	initNiceSelect() {
		console.log('this is inside.')
		setTimeout(() => {
			const $select = $('select[nice-select]');
			$select.niceSelect?.('destroy');  // clean up
			$select.niceSelect();             // re-init
		}, 100);
	}

	getPage(page: number): void {
		this.loaderService.startLoading();
		this.loading = true;

		const params = { page, limit: this.paginator.itemsPerPage, sort: this.sortColumn, direction: this.sortDirection, q: this.searchTerm };

		this.http.get<any>(`${Api.influencerAnalytics.all}?${queryString(params)}`)
			.pipe(catchError(err => {
				this.loaderService.stopLoading();
				this.loading = false;
				return throwError(err);
			}))
			.subscribe(r => {
				if (r.data) {
					this.data = r.data;
				}

				if (r.pagination) {
					this.paginator.totalItems = r.pagination.total;
					this.paginator.itemsPerPage = r.pagination.per_page;
					this.paginator.currentPage = r.pagination.current_page;
					this.paginator.from = r.pagination.from;
					this.paginator.to = r.pagination.to;
				
					setTimeout(() => {
						$('select[nice-select]').niceSelect('update');
					}, 10);
				}
				if (r.summary) {
					this.stats = [
						{
							label: r.summary.total_clicks.label,
							value: r.summary.total_clicks.value,
							percent: r.summary.total_clicks.percent ?? 0,
							isUp: r.summary.total_clicks.percent >= 0,
							change: Math.abs(r.summary.total_clicks.percent)
						},
						{
							label: r.summary.orders_started.label,
							value: r.summary.orders_started.value,
							percent: r.summary.orders_started.percent ?? 0,
							isUp: r.summary.orders_started.percent >= 0,
							change: Math.abs(r.summary.orders_started.percent)
						},
						{
							label: r.summary.orders_placed.label,
							value: r.summary.orders_placed.value,
							percent: r.summary.orders_placed.percent ?? 0,
							isUp: r.summary.orders_placed.percent >= 0,
							change: Math.abs(r.summary.orders_placed.percent)
						},
						{
							label: r.summary.orders_checked_out.label,
							value: r.summary.orders_checked_out.value,
							percent: r.summary.orders_checked_out.percent ?? 0,
							isUp: r.summary.orders_checked_out.percent >= 0,
							change: Math.abs(r.summary.orders_checked_out.percent)
						},
						{
							label: r.summary.order_amount.label,
							value: r.summary.order_amount.value,
							percent: r.summary.order_amount.percent ?? 0,
							isUp: r.summary.order_amount.percent >= 0,
							change: Math.abs(r.summary.order_amount.percent)
						},
						{
							label: r.summary.influencer_payout.label,
							value: r.summary.influencer_payout.value,
							percent: r.summary.influencer_payout.percent ?? 0,
							isUp: r.summary.influencer_payout.percent >= 0,
							change: Math.abs(r.summary.influencer_payout.percent)
						}
					];
				}


				this.onLoad.emit({ totalItems: this.paginator.totalItems });
				this.loaderService.stopLoading();
				this.loading = false;
				this.initNiceSelect();
			});
	}

	onChangeItemsPerPage(event: Event, p: any) {
		const value = +(event.target as HTMLSelectElement).value;
		alert(value)

		this.paginator.itemsPerPage = value;

		this.getPage(1);
		this.initNiceSelect();
	}
}
